import React, { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { ApprovalCaseDetail } from '~/types/approvalCase';
import { useRightContentSpacing } from '~/hooks/styles';
import { useGetTransaction } from '~/hooks/headTransactions';
import AsideDetails from '~/resources/headTransactions/components/aside/AsideDetails';
import ApprovalFlow from '~/components/Approvals/ApprovalFlow';
import { ApprovalAside } from './components/ApprovalAside';
import AsideReferences from '~/resources/headTransactions/components/aside/AsideReferences';
import AffiliatedObjects from '~/components/AffiliatedObjects';

const ApprovalsRightPanel: FC<any> = (props) => {
  const record = props.record as ApprovalCaseDetail | undefined;
  const spacing = useRightContentSpacing();
  const classes = useStyles({ spacing });

  const isTransaction = record?.actionType === 'TRANSACTION';
  const { data: trx } = useGetTransaction(record?.objectId, {
    enabled: isTransaction,
    staleTime: Infinity,
  });

  if (!record) return null;

  return (
    <Grid container item xs direction='column' spacing={spacing}>
      <Grid item className={classes.asideContent}>
        <ApprovalAside record={record} />
        <Box mt={2}>
          <ApprovalFlow record={record} resource={props.resource} />
        </Box>
        {isTransaction && trx && (
          <>
            <Box mt={2}>
              <AsideDetails record={trx} />
            </Box>
            <Box mt={2}>
              {(trx?.details.deal ||
                trx?.details.reversalTransaction ||
                trx?.details.revertedTransaction ||
                trx?.details.approvalTransaction ||
                trx?.details.approvedTransaction ||
                trx?.details.settlementTransaction ||
                trx?.details.settledTransaction ||
                trx?.details.payroll) && <AsideReferences record={trx} />}
            </Box>
          </>
        )}
      </Grid>
      {isTransaction && trx?.details?.references && (
        <AffiliatedObjects
          id={trx.id}
          references={trx?.details?.references}
          resource='transactions'
          withAdd={false}
          withArchive={false}
          withViewAll={false}
        />
      )}
    </Grid>
  );
};

type StylesProps = { spacing: number };

const useStyles = makeStyles<Theme, StylesProps>((theme) => ({
  asideContent: {
    marginLeft: ({ spacing }) => theme.spacing(spacing),
  },
}));

export default ApprovalsRightPanel;
